import { HeroSection } from "./hero-section";
import { NewCustomerSection } from "./new-customer-section";
import { LoyalCustomerSection } from "./loyal-customer-section";
import { PickupExperienceSection } from "./pickup-experience-section";
import { ExposureSection } from "./exposure-section";
import { CategorySection } from "./category-section";
import { CTASection } from "./cta-section";
import { PageIndicator } from "./page-indicator";
import { useState, useEffect, useRef } from "react";
import { LuArrowRight } from "react-icons/lu";
import { track } from "@amplitude/analytics-browser";

export default function IntroductionPage() {
  const [currentPage, setCurrentPage] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const totalPages = 7;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollPosition = container.scrollTop;
      const height = container.clientHeight;
      const page = Math.round(scrollPosition / height);
      setCurrentPage(page);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const handleConsultation = () => {
    track("사장님 입점신청 온보딩 무료상담 버튼 클릭");
    window.location.href =
      "https://docs.google.com/forms/d/1G_NIuIkpHuXW8TfudUJELST4K3-5IziCywwpL5Olcr0/viewform?edit_requested=true";
  };

  return (
    <div className="relative h-screen w-full">
      <div
        ref={containerRef}
        className="h-full w-full overflow-y-scroll snap-y snap-mandatory relative scrollbar-hide"
      >
        <PageIndicator currentPage={currentPage} totalPages={totalPages} />
        <HeroSection />
        <NewCustomerSection />
        <LoyalCustomerSection />
        <PickupExperienceSection />
        <ExposureSection />
        <CategorySection />
        <CTASection />
      </div>

      <div className="fixed bottom-0 left-0 w-full p-5 z-50 bg-gradient-to-t from-white via-white/80 to-transparent">
        <div className="max-w-2xl mx-auto w-full">
          <button
            onClick={handleConsultation}
            className="w-full bg-gray-800 text-white rounded-2xl px-8 py-4 hover:bg-gray-900 transition-colors shadow-lg flex items-center justify-center gap-3 group"
            style={{ fontSize: "1.125rem", fontWeight: 800 }}
          >
            무료로 상담 받아보기
            <LuArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
}
